import '@yourcoach/shared/utils/reset.d';
import 'cross-fetch/polyfill';

import {createRoot} from 'react-dom/client';

import {ThemeProvider} from '@yourcoach/shared/styles';

import {Router} from './routes/Router';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ThemeProvider>
    <Router />
  </ThemeProvider>,
);
